import React, {ReactElement} from 'react';
import {useTimeOverDetector, useMoneyOverDetector} from 'ui/utils/lifeCycle';
import {useIsIncomeMode} from 'store/UserInput';

import {ShowAfterMount} from 'components/ShowAfterMount';
import {Results} from 'components/Results';
import {Counter} from 'components/Counter';
import {LimitBreach} from 'components/LimitBreach';
import {Message} from 'components/Message';

export const Dialogue = (): ReactElement => {
  const timeOver = useTimeOverDetector();
  const moneyOver = useMoneyOverDetector();
  const isIncomeMode = useIsIncomeMode();

  if (timeOver || (moneyOver && !isIncomeMode)) return <Results />;

  return (
    <ShowAfterMount>
      <Counter />
      <LimitBreach />
      <Message />
    </ShowAfterMount>
  );
};
